'use strict';

bbw.shared.HomeSearchCtrl = bbw.shared.SearchCtrl.extend({

    _initLocationAndTabs: function() {
        // pass
    },

    _init: function() {
        this._initScope();
        this._initLangAttrs();
        this._initZodiac();
        this._initGeo();
        this._initRequest();

        this.$scope.ctrlStatus.showForm = true;
        this.$scope.findPage = this.findPage.bind(this);

        return this.$q.all([
            this._langAttrs.loadAttrLists('search'),
            this._langZodiac.loadAttrLists('zodiac'),
            this._loadLastSearch().then(
                this._loadGeo.bind(this)
            ),
            this._findNew(10),
            this._geo.loadCountries()
        ]);
    },

    _doInit: function() {
        this._langAttrs = this._modelFactory.create(bbw.model.Lang).wireScope(this.$scope, 'lang.attrs');
        this._langZodiac = this._modelFactory.create(bbw.model.Lang).wireScope(this.$scope, 'lang.zodiac');
        this._geo = this._modelFactory.create(bbw.model.Geo).setInjectSeparators().wireScope(this.$scope, 'geo');

        var loadOps = [
            this._geo.loadCountries(),
            this._langAttrs.loadAttrLists('profile'),
            this._langZodiac.loadAttrLists('zodiac'),
            this._loadLastSearch().then(
                this._loadGeo.bind(this)
            ),
            this._findNew(10)
        ];

        return this.$q.all(loadOps);
    },

    _setShowForm: function(value) {
        this.$scope.ctrlStatus.showForm = true;
    },

    _findNew: function(limit) {
        this.$scope.ctrlStatus.searching = true;
        return this._rpcClient.post('search/find/new').
            execute().
            then(function(response) {
                if (angular.isDefined(response.count)) {
                    if (!angular.isArray(response.items)) {
                        response.items = [];
                    }
                    if (angular.isDefined(limit)) {
                        if (response.items.length > limit) {
                            response.items.length = limit;
                        }
                    }
                    this.$scope.search.response = response;
                } else {
                    return this.$q.reject('internal_error');
                }
            }.bind(this)).
            catch(function(response) {
                console.error(response);
            }.bind(this)).
            finally(function() {
                delete this.$scope.ctrlStatus.searching;
            }.bind(this));
    }


});
